"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  guid: null,
  portalId: null,
  appId: null,
  emailCampaignId: null,
  message: '',
  createdAt: null,
  permanent: false,
  requestedBy: '',
  thresholdType: '',
  threshold: null,
  thresholdViolation: null,
  sentCount: 0
};

var Suspension =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Suspension, _Record);

  function Suspension() {
    (0, _classCallCheck2.default)(this, Suspension);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Suspension).apply(this, arguments));
  }

  (0, _createClass2.default)(Suspension, null, [{
    key: "from",
    value: function from(json) {
      return new Suspension(json);
    }
  }]);
  return Suspension;
}((0, _immutable.Record)(defaults));

var _default = Suspension;
exports.default = _default;
module.exports = exports.default;